import SmoothScroll from 'smooth-scroll';

const menu = (hamburgerSelector, menuSelector, hamburgerActive, menuActive) => {
    let scroll = new SmoothScroll('a[href*="#"]');

    const hamburger = document.querySelector(hamburgerSelector),
          menu = document.querySelector(menuSelector),
          links = menu.querySelectorAll('.menu__link');

    function toggleMenu() {
        hamburger.classList.toggle(hamburgerActive);
        menu.classList.toggle(menuActive);

        menu.addEventListener('click', (e) => {
            const target = e.target;

            if (target && target.classList.contains('menu__list')) {
                toggleMenu();
            }
        });

        links.forEach(link => { 
            link.addEventListener('click', toggleMenu);
        });
    }

    hamburger.addEventListener('click', toggleMenu);
};

export default menu;